<template lang="pug">
  span
    template(v-if="isSoldOut") Sold Out&nbsp;
    span(:class="{'text-gray-500 ml-10 inline-block': isSoldOut}") {{ price(amount) }}
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProductPrice',
  props: ['isSoldOut', 'amount'],
  computed: {
    ...mapGetters({ price: 'shop/price' })
  }
}
</script>

<style>
</style>
